import {Injectable} from '@angular/core';
import {
  collection,
  collectionData,
  doc,
  Firestore, getDocs, limit,
  orderBy,
  query,
  QueryConstraint,
  startAfter,
  where,
  writeBatch
} from '@angular/fire/firestore';
import { first } from "rxjs";
import { Notification } from "../models/notification.model";
import { TenantService } from "./tenant.service";
import { MessagesService } from "../shared/services/messages.service";
import { Timestamp } from "@firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class UserNotificationsService {

  notifications: Notification[] = [];

  constructor(private tenant: TenantService,
                  private messages: MessagesService,
                  private firestore: Firestore) {

    // this.loadNotificationsPage(0)
    //   .then(() => {
    //     console.log(`First page of notifications loaded.`)
    //   })
  }

  invalidateCache() {
    this.notifications = []
  }

  async loadNotificationsPage(pageNumber: number, userId: string,  lastPostDoc?: Timestamp) {

    try {
      if (!lastPostDoc && this.notifications.length > 0) {
        // Return cached notifications if there are no new posts to fetch
        return this.notifications;
      }

      const constraints: QueryConstraint[] = [
        where("sentToUserId", "==", userId),
        orderBy("createdAt", "desc"),
        limit(pageNumber)
      ];

      if (lastPostDoc) {
        constraints.push(startAfter(lastPostDoc));
      }

      const userNotificationsQuery = query(
        collection(this.firestore, `schools/${this.tenant.id}/userNotifications`),
        ...constraints
      );

      const userNotificationsSnapshot = await getDocs(userNotificationsQuery);
      const userNotifications: Notification[] = userNotificationsSnapshot.docs.map(doc => doc.data() as Notification)

      // Append the new notifications to the existing ones
      this.notifications = [...this.notifications, ...userNotifications];

      return userNotifications;
    } catch (error) {
      const message = `Error loading all user notifications for userId=${userId}`;
      console.error(message, error);
      this.messages.error(message);
    }
  }

  async markAsRead(notification: Notification) {

    const batch = writeBatch(this.firestore)
    const notificationRef = doc(this.firestore, `schools/${this.tenant.id}/userNotifications/${notification.id}`);

    batch.update(notificationRef, notification);

    await batch.commit();

    this.invalidateCache()

  }

  async markAllAsRead(notifications: Notification[]) {

    const batch = writeBatch(this.firestore)

    notifications.forEach(notification => {

      const notificationRef = doc(this.firestore, `schools/${this.tenant.id}/userNotifications/${notification.id}`);
      batch.update(notificationRef, notification);

    })

    await batch.commit();

    this.invalidateCache()

  }

  async zeroOutNotificationsCounter(userId: string) {

    const userPath = `schools/${this.tenant.id}/users/${userId}`
    const userRef = doc(this.firestore, userPath);
    const batch = writeBatch(this.firestore);

    batch.update(userRef, { unreadNotificationsCounter: 0 });

    await batch.commit();

  }
}
